<template>
    <v-flex v-if="productsComplement.length">
        <v-carousel hide-delimiters>
            <v-carousel-item v-for="i in cantCarrousel" :key="i" style="width: 90%;margin: 0 auto;">
                <v-layout >
                    <v-flex sm=2 v-for="(p, j) in productsComplement[i-1]" :key="j" px-2>
                        <v-card elevation="0" light v-if="p.product_name_web!=''">
                            <img
                                :src="!!p.medium_image_url ? (urlApi+pathFileProducts+p.medium_image_url) : require('@/assets/ProductoSinImagen.jpg')"
                                style="width:100%;margin:0 auto;cursor:pointer;"
                                @click="redirectRelatedProduct(p.url_product)"
                                :alt="p.product_name_web" 
                            >
                            <div class='text-center' >
                                <div  class='grayblack--text font-title' style="height: 80px;" v-html=p.product_name_web> </div>
                                <v-btn 
                                    v-if="p.inventory"
                                    rounded 
                                    outlined 
                                    class='btn-quote-products font-title font-weight-black'
                                    @click="addItem(p)"
                                >
                                    <span v-if="loggedIn"> COMPRAR</span>  
                                    <span v-else> AGREGAR</span>  
                                </v-btn>
                                <v-btn 
                                    v-else
                                    rounded 
                                    outlined 
                                    class='btn-quote-products font-title font-weight-black'
                                >
                                    <span> AGOTADO </span>
                                </v-btn>
                            </div>
                        </v-card>
                        <v-card light elevation="0" v-else>
                            <img :src="require('@/assets/blanco.png')" style="width:100%">
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-carousel-item>
        </v-carousel>
    </v-flex>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex'
import Vue from 'vue'

export default {
    name:'LastProductsVisitedComponent',
    data:() =>({
        cantCarrousel:0,
        productsComplement:[],
        selectProduct:{
            product_id:null,
            quantity:0,
            product_name:'',
            images:[]
        },
    }),
    watch:{
        lastProductsVisited: function(){
            this.getLastProductsVisited()
        }
    },
    computed:{

        ...mapState(['lastProductsVisited','urlApi','pathFileProducts','selectedProducts','sweeAlertAddProduct','loggedIn']),
    },
    methods:{

        ...mapActions(['requestApi','dataCarousel','updateQuoteItems']),

        ...mapMutations(['setLastProductsVisited','setUrl','setSelectedProducts','setTotalQuantity','itemShoppingCar','deleteSelectedProducts']),

        getLastProductsVisited(){
      
            if(this.lastProductsVisited.length){
                this.setUrl('busqueda-catalogo')
                this.requestApi({
                    method: 'PATCH',
                    data :{
                        productsId:this.lastProductsVisited
                    }
                }).then(res =>{
                    
                    this.dataCarousel({
                        selectProduct: res.data._embedded.busqueda_catalogo,
                        width: this.$vuetify.breakpoint.width
                    }).then( res => {
                        this.cantCarrousel = res.cantCarrousel
                        this.productsComplement = res.productsComplement
                    })

                })
            }

        },

        redirectRelatedProduct(product_id){
            location.href = `/medicamentos-especialidad/producto/${product_id}`
        },

        addItem(item){
            console.log('item',item)
            this.dialog=true
            let itemExist = this.selectedProducts.find(e => e.product_id == item.product_id)
            console.log('itemExist',itemExist)
            this.selectProduct.quantity=1
            this.selectProduct.inventory = item.inventory
            this.selectProduct.product_id = item.product_id 
            
            if(typeof itemExist !='undefined'){

                let index = this.selectedProducts.indexOf(itemExist)
                this.selectProduct.quantity = this.selectedProducts[index].quantity+1
                this.selectProduct.quoteItemSeqId= itemExist.quoteItemSeqId
                this.selectedProducts.map(obj =>{ 
                    
                    if(obj.product_id == item.product_id)
                        obj.quoteItemSeqId = itemExist.quoteItemSeqId
                       
                    return  obj

                })

                console.log('this.selectedProducts',this.selectedProducts)

            }else{

                this.setSelectedProducts({
                    product_id: item.product_id,
                    internal_name: item.product_name_web,
                    inventory: item.inventory,
                    quantity:1,
                    images: item.medium_image_url,
                    psicotropico: item.psicotropico,
                    price: item.price,
                    tax_value: item.iva,
                    brand_name: item.brand_name,
                    valor_descuento: 0,
                    is_promo: 0, 
                })

            }

            this.selectProduct.product_name= item.product_name_web
            this.selectProduct.images = item.medium_image_url
            let quantities = this.selectedProducts.map(obj=>{ return obj.quantity })
            
            this.setTotalQuantity(quantities.reduce((accumulator, currentValue) => accumulator + currentValue))
            this.itemShoppingCar(this.selectedProducts)

            this.updateQuoteItems({
                action:'add',
                /* cantidad: this.selectProduct.quantity,
                productId: this.selectProduct.product_id,
                quoteId: localStorage.getItem('quote_id') */
            }).then(res=>{

                this.deleteSelectedProducts()
              
                res.data.detail.quoteItems!=null && res.data.detail.quoteItems.forEach(item => {
                
                    this.setSelectedProducts({
                        product_id: item.product_id,
                        images: item.images,
                        price: parseFloat(item.price),
                        quantity: parseFloat(item.quantity),
                        brand_name : item.brand_name,
                        internal_name : item.internal_name,
                        tax_value : parseFloat(item.tax_value),
                        psicotropico: item.psicotropico,
                        quoteItemSeqId: item.quote_item_seq_id,
                        inventory: item.inventory,
                        valor_descuento: isNaN(parseFloat(item.valor_descuento)) ? 0 : parseFloat(item.valor_descuento),
                        is_promo:isNaN(parseFloat(item.is_promo)) ? 0 : parseFloat(item.is_promo), 
                    })

                })  
                
                this.itemShoppingCar(this.selectedProducts)

            }).catch(err=>{

                console.log('err',err)
                /*let products = this.shoppingCar
                let index = products.indexOf(objProduct)
                products.splice(index,1)
                this.itemShoppingCar(products)
                this.overlay=false*/

            })

        },

    },
    created(){

        if(localStorage.getItem('lastProductsVisited')!='' && localStorage.getItem('lastProductsVisited')!= null){
            let products = JSON.parse(localStorage.getItem('lastProductsVisited'))
            this.setLastProductsVisited({product_id: products[0].product_id})   
        }
    
    }
}
</script>
